import { useEffect } from "react";

const BLOCKED_KEYS = new Set(["I", "J", "C"]);
const isTextField = (el) => !!el?.closest?.("input, textarea, [contenteditable='true']");

// Discourages casual right-click / devtools use. Not real security — the browser
// can always read the client bundle, so anything secret must stay on the server.
export const useContentProtection = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const onContextMenu = (e) => {
      if (isTextField(e.target)) return;
      e.preventDefault();
    };

    const onKeyDown = (e) => {
      if (e.key === "F12") return e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && BLOCKED_KEYS.has(e.key.toUpperCase())) return e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && e.key.toUpperCase() === "U" && !isTextField(e.target)) return e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && e.key.toUpperCase() === "S" && !isTextField(e.target)) return e.preventDefault();
    };

    const onDragStart = (e) => {
      if (e.target?.tagName === "IMG") e.preventDefault();
    };

    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("dragstart", onDragStart);
    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("dragstart", onDragStart);
    };
  }, [enabled]);
};

export default useContentProtection;
